import { Box, Text, Flex, Spinner, Button } from '@chakra-ui/react';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../../shared/providers/AuthProvider/AuthProvider";
import { useAppToast } from "../../../../hooks/useAppToast";

const ActivationPage = () => {
    const { activate, error, errorCode } = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation("default");
    const { key } = useParams();
    const [loading, setLoading] = useState(true);
    const [activated, setActivated] = useState(false);
    const [activationError, setActivationError] = useState(null);
    const toast = useAppToast();

    const activateAccount = async () => {
        setLoading(true);
        setActivationError(null);
        try {
            const res = await activate(key);
            if (res) {
                setActivated(true);
            } else {
                setActivationError(error || errorCode || t('activation.error'));
            }
        } catch (err) {
            setActivationError(t('activation.error'));
            toast({ title: t('request.error'), status: 'error', duration: 3000, isClosable: true });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (key) {
            activateAccount();
        } else {
            setLoading(false);
            setActivationError(t('activation.missing_key'));
        }
    }, [key]);

    return (
        <Flex minH={{ base: 'calc(100vh - 64px)', md: 'calc(100vh - 72px)' }} align="center" justify="center" bg="#F8F5F4" px={4}>
            <Box textAlign="center" maxW="520px" w="full" bg="white" border="1px solid #ECE4E4" borderRadius="22px" boxShadow="0 1px 2px rgba(14,26,23,0.04), 0 16px 40px rgba(14,26,23,0.07)" p={{ base: '24px', md: '40px' }} my={{ base: '24px', md: '56px' }}>
                {loading && (
                    <>
                        <Spinner size="xl" color="#7A1F35" mb={4} />
                        <Text fontSize="lg">{t('activation.loading')}</Text>
                    </>
                )}

                {!loading && activated && (
                    <>
                        <Text fontFamily="heading" fontSize="28px" fontWeight="700" letterSpacing="-0.5px" mb={3} color="#7A1F35">
                            {t('activation.title')}
                        </Text>
                        <Text fontSize="lg" mb={6}>
                            {t('activation.message')}
                        </Text>
                        <Button
                            bg="#7A1F35"
                            color="white"
                            _hover={{ bg: "#5C1628" }}
                            onClick={() => navigate('/login')}
                        >
                            {t('login.button')}
                        </Button>
                    </>
                )}

                {!loading && !activated && (
                    <>
                        <Text fontFamily="heading" fontSize="28px" fontWeight="700" letterSpacing="-0.5px" mb={3} color="red.500">
                            {t('activation.error_title')}
                        </Text>
                        <Text fontSize="lg" mb={6} color="gray.600">
                            {activationError || t('activation.error')}
                        </Text>
                        <Button
                            bg="#7A1F35"
                            color="white"
                            _hover={{ bg: "#5C1628" }}
                            onClick={() => navigate('/login')}
                        >
                            {t('login.button')}
                        </Button>
                    </>
                )}
            </Box>
        </Flex>
    );
};

export default ActivationPage;
